import request from '@/utils/request'
const BASE_URL = '/pdd/temp'

export default {
  /** 运费模板同步 */
  sync(mallId = null) {
    var headers = {};
    if (mallId) headers['mallid'] = mallId;
    return request({
      url: BASE_URL + '/sync',
      method: 'post',
      headers: headers
    })
  },
  /** 同步状态查询 */
  syncStatus(mallId = null) {
    var headers = {};
    if (mallId) headers['mallid'] = mallId;
    return request({
      url: BASE_URL + '/syncstatus',
      method: 'get',
      headers: headers
    })
  },
  /** 模板列表 */
  list(mallId = null) {
    var headers = {};
    if (mallId) headers['mallid'] = mallId;
    return request({
      url: BASE_URL,
      method: 'get',
      headers: headers
    })
  },
}
